import React, { useMemo } from "react";

type Cell = { dow: number; hour: number; units_ordered: number };

const DOW = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

const HeatmapGrid = ({ cells }: { cells: Cell[] }) => {
  const { max, map } = useMemo(() => {
    const map = new Map<string, number>();
    let max = 0;
    for (const c of cells) {
      map.set(`${c.dow}:${c.hour}`, c.units_ordered);
      if (c.units_ordered > max) max = c.units_ordered;
    }
    return { max, map };
  }, [cells]);

  const color = (v: number) => {
    if (max <= 0 || v <= 0) return "rgba(0,0,0,0.04)";
    const t = Math.min(1, v / max);
    // teal intensity (avoid purple AI cliché)
    const a = 0.12 + t * 0.85;
    return `rgba(15, 118, 110, ${a})`;
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `48px repeat(24, minmax(18px, 1fr))`,
          gap: 2,
          minWidth: 560,
        }}
      >
        <div />
        {Array.from({ length: 24 }, (_, h) => (
          <div
            key={`h-${h}`}
            style={{
              fontSize: 10,
              textAlign: "center",
              color: "#666",
            }}
          >
            {h}
          </div>
        ))}
        {DOW.map((label, dow) => (
          <React.Fragment key={dow}>
            <div
              style={{
                fontSize: 12,
                display: "flex",
                alignItems: "center",
                color: "#444",
              }}
            >
              {label}
            </div>
            {Array.from({ length: 24 }, (_, hour) => {
              const v = map.get(`${dow}:${hour}`) || 0;
              return (
                <div
                  key={`${dow}-${hour}`}
                  title={`${label} ${String(hour).padStart(2, "0")}:00 — ${v}`}
                  style={{
                    height: 22,
                    borderRadius: 2,
                    background: color(v),
                  }}
                />
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default HeatmapGrid;
